import type { ImageSource } from '@/app/components/media/image/types';
import {
  generateMobileSources,
  generateTabletSources,
} from '@/components/shared/media/image/generate-sources';
import { MEDIA_QUERIES } from '@/components/shared/media/image/Image.constants';
import type { SplashPopup } from '@/services/splash/types';

/**
 * Single source of truth for the splash image variants — used by SplashUI
 * to render the <picture> and by SplashController's inline prehide script
 * to conditionally preload them before hydration (only when the splash
 * will actually show, so a cookie-hidden splash fetches nothing).
 */
export const getSplashImageSources = (
  splash: Pick<SplashPopup, 'imageDesktop' | 'imageMobile'>
): ImageSource[] => [
  {
    srcset: splash.imageDesktop.url,
    media: MEDIA_QUERIES.TABLET_LG,
    options: { crop: '16:9', width: 960 },
  },
  ...generateTabletSources({
    mobileSrc: splash.imageMobile.url,
    mobileOptions: { crop: '3:4' },
  }),
  ...generateMobileSources({
    mobileSrc: splash.imageMobile.url,
    mobileOptions: { crop: '3:4' },
  }),
];
